import AppDispatcher from '../AppDispatcher';

const QuoteHistorySymbolsActions = {
  set: (items) => {
    AppDispatcher.dispatch({
      actionType: Constants.ActionTypes.QUOTE_HISTORY_SYMBOLS.SET,
      items: items
    });
  },
  update: () => {
    AppDispatcher.dispatch({
      actionType: Constants.ActionTypes.QUOTE_HISTORY_SYMBOLS.UPDATE
    });
  }
};

export default QuoteHistorySymbolsActions;



// WEBPACK FOOTER //
// ./src/js/Actions/QuoteHistorySymbolsActions.js